import { gql } from "lib/apolloClient";
import {
  learningCourseUnitPlansFragment,
  learningCourseUnitPlanFeedFragment,
} from "./UnitPlanLearningCourseFragment";

export const getLearningCourseUnitPlanFeedQuery = gql`
  query getLearningCourseUnitPlanFeed(
    $learningCourseId: ID!
    $uids: [String!]
    $first: Int
    $after: String
    $filters: LearningCourseUnitPlanFilter
    $showCollaborators: Boolean!
    $showSharedWithStudentsFamily: Boolean!
    $showWeeksDuration: Boolean!
    $showAssessments: Boolean!
    $showLE: Boolean!
    $showSubjects: Boolean!
    $orderBy: UnitPlanOrderByEnum
    $orderByDirection: OrderByDirectionEnum
    $groupBy: Boolean
    $collaboratorsFilter: CollaboratorFilters
    $exceptionalCollaboratorsFilter: ExceptionalCollaboratorUserFilter
    $classFilter: UnitPlanClassDateFilter
  ) {
    node(id: $learningCourseId, type: LEARNING_COURSE) {
      ... on LearningCourse {
        id
        ...learningCourseUnitPlans
      }
    }
  }
  ${learningCourseUnitPlansFragment.learningCourseUnitPlans}
`;
export const getImportLearningCourseUnitPlanFeedQuery = gql`
  query getImportLearningCourseUnitPlanFeed(
    $learningCourseId: ID!
    $filters: LearningCourseUnitPlanFilter
    $orderByDirection: OrderByDirectionEnum
    $first: Int = 1000
    $after: String
  ) {
    node(id: $learningCourseId, type: LEARNING_COURSE) {
      ... on LearningCourse {
        unitPlans(
          filters: $filters
          first: $first
          after: $after
          orderByDirection: $orderByDirection
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          totalCount
          unitTypeCount {
            type
            count
          }
          edges {
            node {
              id
              title {
                value
              }
              unitType {
                id
                value
              }
              resourceLibrary {
                leCount
              }
              learningCourseFlowResource {
                id
              }
              subjects {
                id
                value
                resolvedMinimalTree {
                  ... on ResolvedFieldSubjectSet {
                    subjects {
                      id
                      name
                    }
                  }
                }
              }
              flowResourceCount {
                leCount
                totalCount
                fileCount
              }
            }
          }
        }
      }
    }
  }
`;

export const getCompleteLearningCourseUnitPlanIdQuery = gql`
  query getCompleteLearningCourseUnitPlanId(
    $learningCourseId: ID!
    $filters: LearningCourseUnitPlanFilter
    $orderByDirection: OrderByDirectionEnum
  ) {
    node(id: $learningCourseId, type: LEARNING_COURSE) {
      ... on LearningCourse {
        unitPlans(
          filters: $filters
          first: 1000
          orderByDirection: $orderByDirection
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              learningCourseFlowResource {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const getCustomOrderingUnitPlansinLearningCourseQuery = gql`
  query getCustomOrderingUnitPlansinLearningCouse(
    $id: ID!
    $first: Int
    $after: String
    $orderBy: UnitPlanOrderByEnum
    $orderByDirection: OrderByDirectionEnum
  ) {
    node(id: $id, type: LEARNING_COURSE) {
      ... on LearningCourse {
        unitPlans(
          first: $first
          after: $after
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          totalCount
          unitTypeCount {
            type
            count
          }
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...learningCourseUnitPlanCustomFeed
            }
          }
        }
      }
    }
  }
  ${learningCourseUnitPlanFeedFragment.learningCourseUnitPlanCustomFeed}
`;
